import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.scss";
import WebLogo from "./WebLogo";
import FacebookLogo from "../images/FacebookLogo";
import { useSelector } from "react-redux";
import TwitterLogo from "../images/TwitterLogo";
import LinkedInLogo from "../images/LinkedInLogo";
import InstagramLogo from "../images/InstagramLogo";
import VideoPlayer from "../components/VideoPlayer/VideoPlayer";

const Footer = () => {
  const footerData = useSelector((state) => state.pages.footer);
  return (
    <footer className={"footer-container"}>
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-6"}>
            <NavLink to={"/"}>
              <WebLogo />
            </NavLink>
          </div>
          <div className={"col-6 text-right social-wrapper"}>
            {footerData.social?.facebook?.length && (
              <NavLink
                target="_blank"
                to={footerData.social.facebook}
                className="footer-social-icon fb">
                <FacebookLogo />
              </NavLink>
            )}
            {footerData.social?.instagram?.length && (
              <NavLink
                target="_blank"
                to={footerData.social.instagram}
                className="footer-social-icon instagram">
                <InstagramLogo />
              </NavLink>
            )}
            {footerData.social?.twitter?.length && (
              <NavLink
                target="_blank"
                to={footerData.social.twitter}
                className="footer-social-icon x">
                <TwitterLogo />
              </NavLink>
            )}
            {footerData.social?.linkedin?.length && (
              <NavLink
                target="_blank"
                to={footerData.social.linkedin}
                className="footer-social-icon in">
                <LinkedInLogo />
              </NavLink>
            )}
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-6"}>
            <ul>
              <li>
                <NavLink
                  to={"/"}
                  className={({ isActive }) => (isActive ? "selected" : "")}>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/about"}
                  className={({ isActive }) => (isActive ? "selected" : "")}>
                  About
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/work"}
                  className={({ isActive }) => (isActive ? "selected" : "")}>
                  Work
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/services"}
                  className={({ isActive }) => (isActive ? "selected" : "")}>
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/blog"}
                  className={({ isActive }) => (isActive ? "selected" : "")}>
                  Blog
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/contact"}
                  className={({ isActive }) => (isActive ? "selected" : "")}>
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
          <div className={"col-6 text-right"}>
            {footerData?.copyright?.text ||
              "© 2024 WebPigment. All rights reserved."}
          </div>
        </div>
      </div>
      <VideoPlayer/>
    </footer>
  );
};

export default Footer;
